import { ILinkedServiceTypeMetadata } from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';
import { ConnectionAuthKind } from 'shell-models-lib';
import { DataSourceOptionKind, CommonResourceKind as ResourceKind } from '@powerquery/mashup-editor-client';
import { adfModelTypeMap } from '../consts/adf-model-type-map-const';
import { GlobalVariables } from 'app/services/globals';
import { compact } from 'lodash';

export const microsoftTeamsMetadata: ILinkedServiceTypeMetadata = {
    type: adfModelTypeMap.microsoftTeams.linkedServiceType,
    displayName: stringResources.Teams,
    icon: {
        className: 'svg-i_Teams_16x16'
    },
    supportedAuthKindsInTrident: compact([
        ConnectionAuthKind.OAuth2,
        GlobalVariables.enableSPNForMicrsoftTeams ? ConnectionAuthKind.ServicePrincipal : undefined
    ]),
    pqoDataSourceOption: {
        kind: DataSourceOptionKind.Extension,
        resourceKind: 'MicrosoftTeams' as ResourceKind
    },
    supportedInTrident: true,
    category: [],
    copySourceTypes: [],
    copySinkTypes: [],
    supportOPDG: true
};
